import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initSentry, Sentry } from "./lib/sentry";

initSentry();

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={<div className="min-h-screen flex items-center justify-center bg-background text-foreground p-6 text-center">Something went wrong. The team has been notified — please refresh.</div>}>
    <App />
  </Sentry.ErrorBoundary>
);
